import { React, useState, useEffect } from 'react';
import ModalPopup from '../../common/ModalPopup/ModalPopup';
import './AddAircraftPopup.scss';
import SuccessPopup from '../SuccessPopup/SuccessPopup';
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { ADD_AIRCRAFT_DETAILS, notificationEnabledPersona } from "../../../helper/constants";
import { useSelector } from "react-redux";
import { AircraftInformationIcon } from "../../pages/SvgIcons/SvgIcons";

import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

import PlaneIcon from '../Hangar/PlaneIcon';
import { Button_V2 } from '../../common/Button_V2';

const AddAircraftPopup = (props) => {


    const DarkTooltip = styled(({ className, ...props }) => (
        <Tooltip placement="top" {...props} classes={{ popper: className }} />
    ))(() => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#384348",
            color: "#FFFFFF",
            fontSize: "14px",
            opacity: 1,
        },
        [`& .${tooltipClasses.arrow}`]: {
            color: "#384348",
        },
    }));


    const [aircraftSoftwareOptions, setAircraftSoftwareOptions] = useState([]);
    const [disabledFlag, setDisabledFlag] = useState(true);
    const [aircraftFmsFlag, setAircraftFmsFlag] = useState(true);
    const [aircraftHangarMake, setAircraftHangarMake] = useState("");
    const [aircraftHangarModel, setAircraftHangarModel] = useState("");
    const [aircraftHangarName, setAircraftHangarName] = useState("");
    const [aircraftHangarSoftware, setAircraftHangarSoftware] = useState("");
    const [isaircraftNotification, setIsAircraftNotification] = useState(false);
    const [isdisabledButton, setIsDisabledButton] = useState(true);
    const [aircraftMakeData, setAircraftMakeData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [aircraftModelLoading, setAircraftModelLoading] = useState(false);
    const [aircraftSoftwareLoading, setAircraftSoftwareLoading] = useState(false);
    const [aircraftModelData, setAircraftModelData] = useState([]);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [showHangarPopup, setShowHangarPopup] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const [hangarLoader, setHangarLoader] = useState(false);
    const [showMetadataPopup, setShowMetadataPopup] = useState(false);
    const [showUpdateSuccessPopup, setShowUpdateSuccessPopup] = useState(false);
    const { userInformation } = useSelector((state) => state.userInformation);
    const [showNotificationToggle, setShowNotificationToggle] = useState(false);
    const { t } = useTranslation();

    const handleEditData = () => {
        if (props?.iseditPopup === true) {
            setAircraftHangarMake(props?.editData?.aircraft_make);
            setAircraftHangarModel(props?.editData?.aircraft_model);
            setAircraftHangarName(props?.editData?.aircraft_name);
            setAircraftHangarSoftware(props?.editData?.fms_version);
            setIsAircraftNotification(props?.editData?.notification_flag);
        }
    };

    const aircraftFMSOptions = [{ label: "All", value: "All" }];

    const handleClose = () => {
        setShowHangarPopup(false);
        props.closepop();
    };

    const getAircraftMakeData = async (hangarMakeValue, hangarModelValue) => {
        try {
            const aircraftMakeDataUrl = "/api/techpub/v1/aircraft-metadata";
            let payload = {};

            if (hangarMakeValue?.length > 0 && !hangarModelValue) {
                payload = { type: "aircraft_model", aircraft_make: hangarMakeValue };
            } else if (hangarMakeValue && hangarModelValue) {
                payload = { type: "fms_version", aircraft_make: hangarMakeValue, aircraft_model: hangarModelValue };
            } else {
                payload = { type: "aircraft_make" };
            }

            if (!hangarMakeValue && !hangarModelValue) { setIsLoading(true); setAircraftModelLoading(false); setAircraftSoftwareLoading(false); }
            if (hangarMakeValue?.length > 0 && !hangarModelValue) { setIsLoading(false); setAircraftModelLoading(true); setAircraftSoftwareLoading(false); }
            if (hangarMakeValue && hangarModelValue) { setIsLoading(false); setAircraftModelLoading(false); setAircraftSoftwareLoading(true); }

            const response = await fetch(aircraftMakeDataUrl, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
            const data = await response.json();

            setIsLoading(false); setAircraftModelLoading(false); setAircraftSoftwareLoading(false);

            let aircraftData = []; let aircraftModelData = []; let aircraftSoftwareData = []; let combinedSoftwareData = [];

            data?.message?.result?.aircraftData?.map((item) => {
                if (!hangarMakeValue && !hangarModelValue) { aircraftData.push({ label: item.value, value: item.value }); }
                if (hangarMakeValue?.length > 0 && !hangarModelValue) { aircraftModelData.push({ label: item.value, value: item.value }); }
                if (hangarMakeValue && hangarModelValue) { aircraftSoftwareData.push({ label: item.value, value: item.value }); }
            });

            if (!hangarMakeValue && !hangarModelValue) { setAircraftMakeData(aircraftData); }
            if (hangarMakeValue?.length > 0 && !hangarModelValue) { setAircraftModelData(aircraftModelData); }
            if (hangarMakeValue && hangarModelValue) {
                setAircraftSoftwareOptions(aircraftSoftwareData);
                if (!aircraftSoftwareLoading && hangarModelValue && aircraftSoftwareData.length === 0) { setAircraftHangarSoftware("All"); }
                if (!aircraftSoftwareLoading && hangarModelValue && aircraftSoftwareData.length > 0) {
                    combinedSoftwareData = aircraftSoftwareData.concat(aircraftFMSOptions);
                    setAircraftSoftwareOptions(combinedSoftwareData);
                }
            }

            setIsLoading(false); setAircraftModelLoading(false); setAircraftSoftwareLoading(false);

        } catch (error) { console.log("error" + error.message); }
    };

    const handleUpdate = async () => {
        setIsDisabledButton(true);
        try {
            const updateHangarDetailsUrl = "/api/techpub/v1/update-user-hangars";
            const payload = {
                id: props?.editData?.id.toString(),
                aircraft_make: aircraftHangarMake,
                aircraft_model: aircraftHangarModel,
                fms_version: aircraftHangarSoftware,
                aircraft_name: aircraftHangarName,
                notification_flag: isaircraftNotification
            };
            const response = await fetch(updateHangarDetailsUrl, { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
            const data = await response.json();

            if (data?.message?.result?.successMessage) {
                setIsSuccess(true);
                setShowUpdateSuccessPopup(true);
                setShowHangarPopup(true);
                setSuccessMessage(data?.message?.result?.successMessage);
                props?.fetchHangarList();
                setShowMetadataPopup(false);
            } else if (data?.message?.result?.errorMessage) {
                setIsSuccess(false);
                setShowUpdateSuccessPopup(true);
                setShowHangarPopup(true);
                setErrorMessage(data?.message?.result?.errorMessage);
                props?.fetchHangarList();
                setShowMetadataPopup(false);
            }
        } catch (error) { }
    };

    const handleSubmit = async () => {
        setHangarLoader(true);
        setIsDisabledButton(true);
        try {
            const saveHangarDetailsUrl = "/api/techpub/v1/save-hangar-details";
            const payload = {
                aircraft_make: aircraftHangarMake,
                aircraft_model: aircraftHangarModel,
                fms_version: aircraftHangarSoftware,
                aircraft_name: aircraftHangarName,
                notification_flag: isaircraftNotification
            };
            const response = await fetch(saveHangarDetailsUrl, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
            const data = await response.json();

            if (data?.message?.result?.successMessage) {
                setIsSuccess(true);
                setShowHangarPopup(true);
                setSuccessMessage(data?.message?.result?.successMessage);
                props?.fetchHangarList();
                setShowMetadataPopup(false);
                setIsError(false);
            } else if (data?.message?.result?.errorMessage) {
                setIsSuccess(false);
                setIsError(true);
                setShowHangarPopup(true);
                setErrorMessage(data?.message?.result?.errorMessage);
                props?.fetchHangarList();
                setShowMetadataPopup(false);
            }
        } catch (error) { console.log("error" + error.message); }
    };

    const getAircraftFMS = (e) => {
        if (e?.value === "All") { setAircraftHangarSoftware("All"); }
        else if (aircraftSoftwareOptions?.length > 0) { setAircraftHangarSoftware(e?.value); }
        else if (aircraftFMSOptions?.length > 0) { setAircraftHangarSoftware(e?.value); }
        else { setAircraftHangarSoftware(""); }
    };

    const getAircraftName = (e) => {
        const sanitizedValue = e?.target?.value.replace(/[^A-Za-z0-9 ]/g, "");
        setAircraftHangarName(sanitizedValue);
    };

    const handleNotificationChange = (e) => { setIsAircraftNotification(e.target.checked); };

    const getAircraftMakeDetails = (e) => {
        if (e?.value?.length > 0) {
            setDisabledFlag(false);
            setAircraftFmsFlag(true);
            setAircraftHangarMake(e?.value);
            setAircraftHangarModel("");
            setAircraftHangarSoftware("");
            setAircraftModelLoading(true);
            setAircraftSoftwareLoading(false);
            getAircraftMakeData(e?.value);
        }
    };

    const handleEditDisabledButton = () => { if (props?.iseditPopup) { setIsDisabledButton(false); } };

    const handleDisabledButton = () => {
        if (aircraftHangarMake !== "" && aircraftHangarModel !== "" && aircraftHangarSoftware !== "") { setIsDisabledButton(false); }
        else { setIsDisabledButton(true); }
    };

    const getAircraftModel = (e, aircraftHangarMake) => {
        if (e?.value?.length > 0) {
            setAircraftHangarModel(e?.value);
            setAircraftHangarSoftware("");
            setDisabledFlag(false);
            setAircraftFmsFlag(false);
            setAircraftSoftwareLoading(true);
            getAircraftMakeData(aircraftHangarMake, e?.value);
        } else { setAircraftFmsFlag(true); }
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: "40px",
            backgroundColor: state.isDisabled ? "#F3F4F6" : provided.backgroundColor,
            cursor: state.isDisabled ? "not-allowed" : "pointer",
            boxShadow: "none",
            border: state.isDisabled
                ? "1px solid #A2A6A8"
                : state.isFocused
                    ? "2px solid #3d9295"
                    : "1px solid #D9D9D9",

            "&:hover": {
                border: state.isDisabled
                    ? "1px solid #A2A6A8"
                    : state.isFocused
                        ? "2px solid #3d9295"
                        : "1px solid #D9D9D9",
            },

        }),
        placeholder: (provided, state) => ({
            ...provided,
            fontStyle: "italic",
            color: state.isDisabled ? "#A2A6A8" : "#4D5761",
        }),
        singleValue: (provided, state) => ({
            ...provided,
            fontStyle: "normal",
            color: state.isDisabled ? "#A2A6A8" : "#1E1E25",
        }),
        indicatorSeparator: () => ({ display: "none" }),
        menu: (provided) => ({ ...provided, maxHeight: "200px", overflowY: "auto" }),
        menuList: (provided) => ({ ...provided, maxHeight: "200px", overflowY: "auto" }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? "#3d9295"
                : state.isFocused
                    ? "#EAEBEB"
                    : "transparent",
            color: state.isSelected ? "#FFFFFF" : provided.color,
            cursor: "pointer",
            "&:hover": {
                backgroundColor: state.isSelected ? "#3d9295" : "#EAEBEB",
            },
            "&:active": {
                backgroundColor: state.isSelected ? "#3d9295" : "#EAEBEB",
            },
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            color: "#1E1E25",
            transition: "transform 0.2s ease",
            transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
            "&:hover": {
                color: "#1E1E25",
            },
        }),
    };

    useEffect(() => {
        if (props?.iseditPopup === true) {
            handleEditData();
            if (props?.editData?.aircraft_make && props?.editData?.aircraft_model) {
                getAircraftMakeData(props?.editData?.aircraft_make, props?.editData?.aircraft_model);
            }
            handleEditDisabledButton();
        } else { getAircraftMakeData(); }
    }, [props?.iseditPopup, props?.editData?.aircraft_make, props?.editData?.aircraft_model]);

    useEffect(() => { handleDisabledButton(); }, [aircraftHangarMake, aircraftHangarModel, aircraftHangarSoftware]);

    return (
        <>
            {!showHangarPopup &&
                <ModalPopup
                    showPopup={props.show}
                    size="lg"
                    arialabel="welcome popup"
                    modalClass="add-aircraft-wrapper"
                    closeButtonClassName="cls-closebutton"
                    centered="true"
                    header={<>
                        <PlaneIcon size={32} color="#1E1E25" />
                        <h3 className="cls-aircraftTitle">
                            {props?.iseditPopup
                                ? t(ADD_AIRCRAFT_DETAILS.EDIT_AIRCRAFT_TITLE)
                                : t(ADD_AIRCRAFT_DETAILS.TITLE)}
                        </h3>
                    </>}
                    body={
                        <>
                            {/* LAYOUT: icon LEFT column, all content RIGHT column */}
                            <div className="cls-modalLayout">

                                {/* LEFT: plane icon only — fixed 32x32 */}


                                {/* RIGHT: everything else */}
                                <div className="cls-modalContent">

                                    {/* Title */}


                                    {/* Description */}
                                    {!props?.iseditPopup && (
                                        <p className="cls-aircraftHead">
                                            {t(ADD_AIRCRAFT_DETAILS.ADD_AIRCRAFT_HEADING)}
                                        </p>
                                    )}

                                    <form>
                                        {/* Aircraft Make + Model */}
                                        <div className="cls-aircraftMakeDrop">
                                            <div className="row">
                                                <div className="col-6">

                                                    <label
                                                        className={`cls-aircraftLabel ${props?.iseditPopup ? "cls-aircraftLabelDisabled" : ""
                                                            }`}
                                                    >
                                                        {t(ADD_AIRCRAFT_DETAILS.AIRCRAFT_MAKE)}</label>
                                                    <span
                                                        className={`cls-aircraftReq ${props?.iseditPopup ? "cls-aircraftLabelDisabled" : ""
                                                            }`}
                                                    >{t(ADD_AIRCRAFT_DETAILS.AIRCRAFT_REQUIRED)}</span>
                                                    {props?.iseditPopup ? (
                                                        <Select
                                                            styles={customStyles}
                                                            isSearchable
                                                            placeholder={props?.editData?.aircraft_make}
                                                            aria-label="aircraft_details"
                                                            required
                                                            value={props?.editData?.aircraft_make ? { label: props?.editData?.aircraft_make, value: props?.editData?.aircraft_make } : null}
                                                            isLoading={isLoading ? true : false}
                                                            isDisabled={true}
                                                        />
                                                    ) : (
                                                        <Select
                                                            styles={customStyles}
                                                            onChange={(e) => getAircraftMakeDetails(e)}
                                                            options={aircraftMakeData}
                                                            isSearchable
                                                            placeholder="Select"
                                                            aria-label="aircraft_details"
                                                            required
                                                            value={aircraftMakeData?.find(item => item?.value === aircraftHangarMake)}
                                                            isLoading={isLoading ? true : false}
                                                            isDisabled={false}
                                                        />
                                                    )}
                                                </div>
                                                <div className="col-6">
                                                    <label
                                                        className={`cls-aircraftLabel ${(props?.iseditPopup || disabledFlag) ? "cls-aircraftLabelDisabled" : ""
                                                            }`}
                                                    >{t(ADD_AIRCRAFT_DETAILS.AIRCRAFT_MODEL)}</label>
                                                    <span
                                                        className={`cls-aircraftReq ${(props?.iseditPopup || disabledFlag) ? "cls-aircraftLabelDisabled" : ""
                                                            }`}
                                                    >{t(ADD_AIRCRAFT_DETAILS.AIRCRAFT_REQUIRED)}</span>
                                                    {props?.iseditPopup ? (
                                                        <Select
                                                            styles={customStyles}
                                                            placeholder={props?.editData?.aircraft_model}
                                                            aria-label="aircraft_model_details"
                                                            isDisabled={true}
                                                            required
                                                            value={props?.editData?.aircraft_model ? { label: props?.editData?.aircraft_model, value: props?.editData?.aircraft_model } : null}
                                                            isLoading={aircraftModelLoading ? true : false}
                                                        />
                                                    ) : (
                                                        <Select
                                                            styles={customStyles}
                                                            onChange={(e) => getAircraftModel(e, aircraftHangarMake)}
                                                            options={aircraftModelData}
                                                            isSearchable
                                                            placeholder="Select Model"
                                                            aria-label="aircraft_model_details"
                                                            isDisabled={disabledFlag ? true : false}
                                                            required
                                                            value={aircraftModelData?.find(item => item?.value === aircraftHangarModel) || ""}
                                                            isLoading={aircraftModelLoading ? true : false}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Aircraft Name + Software Version */}
                                        <div className="cls-aircraftNameDetails">
                                            <div className="row">
                                                <div className="col-6">
                                                    <label className="cls-aircraftLabel">{t(ADD_AIRCRAFT_DETAILS.AIRCRAFT_NAME)}</label>
                                                    {/* <Tooltip title={t(ADD_AIRCRAFT_DETAILS.ADD_AIRCRAFT_TAIL_INFO)} arrow placement="top">
                                                        <span className="cls-aircraftIcon"><AircraftInformationIcon /></span>
                                                    </Tooltip> */}

                                                    <DarkTooltip
                                                        title={t(ADD_AIRCRAFT_DETAILS.AIRCRAFT_NAME)}
                                                        arrow
                                                    >
                                                        <span className="cls-aircraftIcon">
                                                            <AircraftInformationIcon />
                                                        </span>
                                                    </DarkTooltip>
                                                    <input
                                                        type="text"
                                                        name="aircraftName"
                                                        pattern="[A-Za-z0-9 ]*"
                                                        placeholder="Type Name"
                                                        maxLength={30}
                                                        value={aircraftHangarName}
                                                        onChange={(e) => getAircraftName(e)}
                                                        className="cls-aircraftNameInput"
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <label
                                                        className={`cls-aircraftLabel ${!props?.iseditPopup && aircraftFmsFlag ? "cls-aircraftLabelDisabled" : ""
                                                            }`}
                                                    >{t(ADD_AIRCRAFT_DETAILS.AIRCRAFT_SOFTWARE_VERSION)}</label>
                                                    <span
                                                        className={`cls-aircraftReq ${!props?.iseditPopup && aircraftFmsFlag ? "cls-aircraftLabelDisabled" : ""
                                                            }`}
                                                    >{t(ADD_AIRCRAFT_DETAILS.AIRCRAFT_REQUIRED)}</span>

                                                    <DarkTooltip
                                                        title={t(ADD_AIRCRAFT_DETAILS.ADD_AIRCRAFT_FMS_VERSION_TAIL_INFO)}
                                                        arrow
                                                    >
                                                        <span className="cls-aircraftIcon">
                                                            <AircraftInformationIcon />
                                                        </span>
                                                    </DarkTooltip>

                                                    {props?.iseditPopup ? (
                                                        <Select
                                                            styles={customStyles}
                                                            onChange={(e) => getAircraftFMS(e)}
                                                            options={aircraftSoftwareOptions?.length > 0 ? aircraftSoftwareOptions : aircraftFMSOptions}
                                                            isSearchable
                                                            placeholder={props?.editData?.fms_version}
                                                            aria-label="aircraft_software_details"
                                                            isDisabled={false}
                                                            required
                                                            value={aircraftSoftwareOptions?.find(item => item?.value === aircraftHangarSoftware) || aircraftFMSOptions?.find(item => item?.value === aircraftHangarSoftware) || ""}
                                                            isLoading={aircraftSoftwareLoading ? true : false}
                                                        />
                                                    ) : (
                                                        <Select
                                                            styles={customStyles}
                                                            onChange={(e) => getAircraftFMS(e)}
                                                            options={aircraftSoftwareOptions?.length > 0 ? aircraftSoftwareOptions : aircraftFMSOptions}
                                                            isSearchable
                                                            placeholder="Select Software Version"
                                                            aria-label="aircraft_software_details"
                                                            isDisabled={aircraftFmsFlag}
                                                            required
                                                            value={aircraftSoftwareLoading ? "" : (aircraftHangarModel && aircraftSoftwareOptions?.length === 0) ? aircraftFMSOptions[0] : aircraftSoftwareOptions?.find(item => item?.value === aircraftHangarSoftware) || aircraftFMSOptions?.find(item => item?.value === aircraftHangarSoftware) || ""}
                                                            isLoading={aircraftSoftwareLoading ? true : false}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Email Notifications */}
                                        <div className="cls-emailNotifications">
                                            <label className="cls-switchSection">
                                                <input
                                                    type="checkbox"
                                                    onChange={(e) => handleNotificationChange(e)}
                                                    checked={isaircraftNotification}
                                                    aria-label="notification-toggle"
                                                />
                                                <span className="cls-switchSlider cls-switchRound"></span>
                                            </label>
                                            <div className="cls-emailNotificationsText">
                                                <p className="cls-aircraftEmail">{t(ADD_AIRCRAFT_DETAILS.EMAIL_NOTIFICATIONS)}</p>
                                                <p className="cls-aircraftEmailText">{t(ADD_AIRCRAFT_DETAILS.EMAIL_NOTIFICATIONS_TEXT)}</p>
                                            </div>
                                        </div>
                                    </form>

                                    {/* Buttons — right aligned */}
                                    <div className="cls-aircraftEmailButton">
                                        <Button_V2
                                            type="secondary"
                                            mode="default"
                                            size="medium"
                                            onClick={props?.closepop}
                                        >
                                            {t(ADD_AIRCRAFT_DETAILS.CANCEL)}
                                        </Button_V2>
                                        {/* <button className="cls-aircraftEmailBtn" onClick={props?.closepop}>
                                            {t(ADD_AIRCRAFT_DETAILS.CANCEL)}
                                        </button> */}
                                        <Button_V2
                                            type="primary"
                                            mode="default"
                                            size="medium"
                                            onClick={props?.iseditPopup ? handleUpdate : handleSubmit}
                                            disabled={props?.iseditPopup ? false : isdisabledButton}
                                        >
                                            {props?.iseditPopup ? t(ADD_AIRCRAFT_DETAILS.SAVE) : t(ADD_AIRCRAFT_DETAILS.AIRCRAFT_ADD)}
                                        </Button_V2>
                                        {/* <button
                                            disabled={props?.iseditPopup ? false : isdisabledButton}
                                            className={isdisabledButton ? "cls-aircraftDisabledButton" : "cls-aircraftAddBtn"}
                                            onClick={props?.iseditPopup ? handleUpdate : handleSubmit}
                                        >
                                            {props?.iseditPopup ? t(ADD_AIRCRAFT_DETAILS.SAVE) : t(ADD_AIRCRAFT_DETAILS.AIRCRAFT_ADD)}
                                        </button> */}
                                    </div>

                                </div>
                            </div>
                        </>
                    }
                    cancelPopup={props.iseditPopup ? props.closepop : props.closepop}
                />
            }

            {(showHangarPopup && !showMetadataPopup) &&
                <SuccessPopup
                    show={props.iseditPopup ? showUpdateSuccessPopup : showHangarPopup}
                    successMessage={successMessage}
                    errorMessage={errorMessage}
                    closePopup={handleClose}
                    messageFlag={isSuccess}
                    fetchHangarList={props?.fetchHangarList}
                />
            }
        </>
    );
};

export default AddAircraftPopup;